import { Role } from '@/types/role'

export const FULL_ACCESS_ROLES = [Role.ADMIN]
